<template>
	<div>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col">
	            <div class="custom-header-banner">
	              <img src="../static/eematico-toys-banner.jpg" alt="eematico toys" class="fluid-img">
	              <div class="custom-banner-text">
	                <h1>Jucării de neuitat</h1>

	                <p>Meșterim jucării pentru a le oferi copiilor ocazia să <span>exploreze</span> și să  <span>descopere</span> lumea <span>prin joacă.</span> Și astfel, învățînd, să poată să se joace cât mai mult timp.</p>

	                <p>Jucării pentru  <span>meșterit</span>, jucării pentru  <span>joacă</span>, jucării pentru  <span>învățat;</span> Jucării pentru <span>mâini</span>, jucării pentru <span>minte</span>, jucării pentru <span>inimă</span>; Jucării <span>de neuitat…</span></p>

	                <h2><span>Într-un cuvânt: jucăriile eematico!</span></h2>

	                <p>Primele modele de jucării sunt disponibile în serii limitate pentru a fi achiziționate. Dacă vă plac, contactați-ne cu ajutorul butonului <span>I`m interested.</span></p>
	                <span @click="scrollToProducts" class="custom-arrow-down"> </span>
	              </div>
	            </div>

	        </v-col>
	      </v-row>
	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-col cols="12" class="custom-padding-col">
	        <v-row>
	          <div class="custom-items-container">
	            <div class="custom-item-top">
	              <h2>învățare</h2>
	              <img src="../static/eematico-toys-jucarii-invatare.png" alt="eematico toys jucarii invatare">
	              <p>jucăriile noastre oferă numeroase oportunități de învățare.</p>
	            </div>
	            <div class="custom-item-top">
	              <h2>provocări</h2>
	              <img src="../static/eematico-toys-jucarii-provocari.png" alt="eematico toys jucarii provocări">
	              <p>copilul tau învață să depașească limite prin activitatea de asamblare a jucariei. Noi o meșterim, el o asamblează.</p>
	            </div>
	            <div class="custom-item-top">
	              <h2>distracție pentru părinți</h2>
	              <img src="../static/eematico-toys-jucarii-distractie.png" alt="eematico toys jucarii distractie">
	              <p>descoperă alături de noi jucăriile de care nu pot sta departe nici macar părinții. Descoperă și asamblează jucăria alaturi de copilul tau!</p>
	            </div>
	            <div class="custom-item-top">
	              <h2>oportunități pentru artiști</h2>
	              <img src="../static/eematico-toys-jucarii-oportunitati.png" alt="eematico toys jucarii oportunități">
	              <p>jucăriile noastre gândite cu drag oferă copilului tău oportunitatea de a își face o jucărie unică: ea vine cât mai simplă astfel încât să poți colora sau chiar da formă personajelor și altor componente ale sale.</p>
	            </div>
	            <div class="custom-item-top last-item">
	              <h2>jucării pentru COPII</h2>
	              <img src="../static/eematico-toys-jucarii-invatare.png" alt="eematico toys jucarii invatare">
	              <p>jucăriile noastre nu sunt pentru baieți sau fete, sunt pentru baieți ȘI fete.</p>
	            </div>            
	          </div>  
	        </v-row>                            
	      </v-col>

	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col custom-products-container">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle" id="products">PRODUSELE NOASTRE</h2>
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-automatorul.jpg" class="fluid-img" alt="eematico toys jucarii automatorul"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Automatonul (kit de asamblare)</h2>
	                <p>Automatonul este o jucărie care utilizează roți dințate pentru a anima personaje. Camele și tacheții, mecanisme inspirate din motorul cu combustie modern, determină mișcarea celor două personaje. Provocarea pentru cei mici este să urmărească această mișcare și să-și folosească creativitatea pentru a personaliza figurinele de lemn. Jucăria are informații inscripționate, și un vocabular tipărit din care copiii pot învăța multe lucruri fascinante.</p>
	                <p>Jucăria vine cu un vocabular, lipici și șmirghel. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să-și asambleze jucăria. Sau puteți să urmăriți filmulețul instructional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 5 ani</strong><br/> Preț: <strong> 80 Lei</strong></span>

	                <v-btn class="custom-button-form" @click.prevent="goToForm('Automaton (kit de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>                
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Caruselul (kit de asamblare)</h2>
	                <p>Caruselul este o jucărie distractivă, pe care copiii o pot asambla singuri. Aceasta ilustrează foarte bine conceptul fizic de inerție: copiii învârt discul, apoi observă cum acesta se răsucește într-o direcție, apoi în cealaltă pentru o perioadă lungă. Astfel pot descoperi și cum influențează numărul de personaje și greutatea lor numărul de rotații și vor afla că inerția ține și de masa corpurilor. În plus, caruselul este prevăzut și cu un labirint, prin care copiii se pot distra cu bila de lemn din cutie, antrenându-și altfel și abilități ce țin de coordonare și motricitate.</p>
	                <p>Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să își asambleze jucăria. Sau puteți să urmăriți filmulețul instrucțional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 3 ani</strong><br/> Preț: <strong> 70 Lei</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Carusel (kit de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>                    
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-jucarii-caruselul.jpg" class="fluid-img" alt="eematico toys jucarii caruselul"/>
	            </v-col>            
	          </v-row> 
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-geo-puzzle.jpg" class="fluid-img" alt="eematico toys jucarii geo-puzzle"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Geo—puzzle</h2>
	                <p>Copilului tău îi place geometria? Știe ce este teselarea (formă specială de mozaicare)? Îi plac puzzle-urile? Dacă răspunsul este da la toate trei întrebările atunci va îndrăgi această frumoasă jucărie care este aproape o lucrare de artă. Dacă nu îi place (sau nu știe ce este) geometria, va începe să o facă dupa ce va încerca puzzle-urile noastre și va descoperi noi concepte. Dacă nu știe ce este teselarea (mozaicare) va înțelege cu acest puzzle, ba chiar va învăța cum să facă alte modele. Dacă nu îi plac puzzle-urile, satisfacția pe care i-o va da completarea unui puzzle de-al nostru îl va face să își schimbe părerea….</p>
	                <p>Are 25 / 46 / 36 de piese (funcție de model)<br/>
	                Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să rezolve puzzle-ul.</p>
	                <span>Vârsta recomandată: <strong>&gt; 3 ani</strong><br/> Preț: <strong>  80 / 90 / 100 Lei</strong></span>
	                 <v-btn class="custom-button-form" @click.prevent="goToForm('Geo—puzzle')" :height="'auto'">SUNT INTERESAT</v-btn>                  
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Presa de ștampile (kit de asamblare)</h2>
	                <p>Copiilor le plac ștampilele, dar vor fi fascinați de presa pentru ștampile. Aceasta este o jucărie simplu de asamblat chiar de către copii, în aproximativ 20 de minute. Le va oferi o multitudine de variante de imprima propriile ștampile pe diverse suprafețe. Pentru copiii mai mari, este mijlocul ideal de a învăța despre pârghia de clasa 2, dar și despre pârghii în general. Iar copiii mai mici vor prinde câteva noțiuni care le vor fi ulterior utile în școală, doar jucându-se cu presa acum.</p>
	                <p>Jucăria vine cu un vocabular, lipici, șmirghel, șurub, piulița, șaibe, cep, material pentru ștampilă și câteva suprafețe de ștampilat. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să își asambleze jucăria. Sau puteți să urmăriți filmulețul instrucțional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 3 ani</strong><br/> Preț: <strong> 72 Lei</strong></span>
	               <v-btn class="custom-button-form" @click.prevent="goToForm('Presa de ștampile (kit de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>        
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-jucarii-presa-de-stampile.jpg" class="fluid-img" alt="eematico toys jucarii presa de stampile"/>
	            </v-col>            
	          </v-row>   
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-rubo-car.jpg" class="fluid-img" alt="eematico toys jucarii rubo car"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Rubo car (kit de asamblare)</h2>
	                <p>Toată lumea iubește mașinile, fete, băieți, femei, bărbați și chiar și cei care merg doar cu bicicleta. Mașinile sunt un simbol al libertății și sunt capabile să depășească orice granițe. Deci o mașină de jucărie este OBLIGATORIE :) Mașina Rubo se asamblează, lăsând loc de multă imaginație din partea copiilor atunci când vine vorba de decorarea acesteia. Partea cea mai distractivă este că are un motor, unul care funcționează cu un elastic, ceea ce îl face extrem de fiabil. Mașina are chiar și roți cauciucate care îi vor învăța pe copii câteva noțiuni despre mișcarea corpurilor și geometrie, dar și despre mașini în general.</p>
	                <p>Jucăria vine cu un vocabular, lipici, cârlig și benzi elastice. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să își asambleze jucăria. Sau puteți să urmăriți filmulețul instrucțional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 3 ani</strong><br/> Preț: <strong>  75 Lei</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('RuboCar')" :height="'auto'">SUNT INTERESAT</v-btn>            
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Kitul de construire</h2>
	                <p>Lemnul și domeniul construcțiilor sunt conectate încă de la începutul timpurilor. Lemnul și metalul au fost un punct de cotitură în evoluția modului în care se construiește. Așadar, acest set de construcție, format din piese modulare, șuruburi și piulițe vor pune baza multor aventuri în arta construcțiilor. Copiii vor putea realiza sute de combinații, de tipuri de structuri, își vor da frâu liber imaginației și își vor antrena motricitatea fină. Iar dacă rezultatul nu este pe măsura așteptărilor, o pot lua oricând de la 0, de câte ori își doresc.</p>
	                <p>Jucăria vine cu destule șuruburi, piulițe și șaibe. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să construiască.</p>
	                <span>Vârsta recomandată: <strong>&gt; 5 ani</strong><br/> Preț: <strong> 85 Lei</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Kitul de construire')" :height="'auto'">SUNT INTERESAT</v-btn>             
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-kit-de-construire.jpg" class="fluid-img" alt="eematico toys jucarii kit de construire"/>
	            </v-col>            
	          </v-row>     
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-racing-kit.jpg" class="fluid-img" alt="eematico toys jucarii racing kit"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Racing Kit</h2>
	                <p>Trei modele de mașinuțe Rubocar, urbană, sport și clasică, vin în kituri de asamblare, împreună cu propria pistă de curse. Testează-le viteza pe pistă și află care este câștigătoarea. Fiecare mașinuță poate fi decorată diferit, lăsând loc de multă imaginație. Colecția de trei mașinuțe Rubocar și pista de curse sunt recomandate pentru joacă și bricolaj de la vârsta de 5 ani împreună cu părinții și de la 7 ani singuri.</p>
	                <p>Fiecare kit de asamblare vine cu un vocabular, lipici și șmirghel. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să-și asambleze jucăria. Sau puteți să urmăriți filmulețul instrucțional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 5 ani</strong><br/> Preț: <strong>  298 Lei si transport gratuit in zona de acoperire Fan Courier</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Racing Kit (kit de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>               
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Toy Sixpack</h2>
	                <p>Construiește un mic univers cu toată colecția de jucării eematico, colecție ce include: Automatonul, Caruselul, Puzzle-ul triunghiular, Presa de ștampile, Rubo car și Kitul de construire. Colecția care include toate cele șase jucării dezvoltă imaginația copiilor, ei fiind provocați să creeze fel și fel de combinații de joacă în care să fie folosite mai multe jucării.</p>
	                <p>Jucăriile sunt recomandate pentru copii de peste 5 ani. Fiecare kit de asamblare vine cu un vocabular, lipici și șmirghel. Kitul de construire este însoțit de șuruburi, piulițe și șaibe. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să-și asambleze jucăria. Sau puteți să urmăriți filmulețul instructional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 5 ani</strong><br/> Preț: <strong> 455 Lei si transport gratuit in zona de acoperire Fan Courier</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Toy Sixpack (kit-uri de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>                 
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-jucarii-toy-sixpack.jpg" class="fluid-img" alt="eematico toys jucarii toy sixpack"/>
	            </v-col>            
	          </v-row>     
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-pachet-dynamic.jpg" class="fluid-img" alt="eematico toys jucarii pachet dynamic"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Pachet Dynamic</h2>
	                <p>Colecția Dynamic include Kitul de asamblare Rubocar, Kitul de asamblare Carusel și 4 figurine gravate. Mișcarea corpurilor este secretul jucăriilor, iar figurinele își așteaptă rândul în cursa fascinantă a Caruselului.</p>
	                <p>Cele două kituri sunt recomandate pentru joacă și bricolaj de la vârsta de 5 ani împreună cu părinții și de la 7 ani singuri. Fiecare kit de asamblare vine cu un vocabular, lipici și șmirghel. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să-și asambleze jucăria. Sau puteți să urmăriți filmulețul instructional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 5 ani</strong><br/> Preț: <strong>  122 Lei</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Pachetul Dinamic (kit-uri de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>                
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Pachet Discovery</h2>
	                <p>Colecția Discovery include Kitul de asamblare Automaton, Kitul de asamblare a Presei de Ștampile și 3 figurine gravate pentru Automaton. Copiii studiază mecanismele, animează personajele sau decorează în fel și chip figurinele.</p>
	                <p>Cele două kituri sunt recomandate pentru joacă și bricolaj de la vârsta de 5 ani împreună cu părinții și de la 7 ani singuri. Fiecare kit de jucărie vine cu un vocabular, lipici și șmirghel. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să-și asambleze jucăria. Sau puteți să urmăriți filmulețul instructional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 5 ani</strong><br/> Preț: <strong> 128 Lei </strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Pachetul Discovery (kit-uri de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>            
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-jucarii-pachet-discovery.jpg" class="fluid-img" alt="eematico toys pachet discovery"/>
	            </v-col>            
	          </v-row>   
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-pachet-contructor.jpg" class="fluid-img" alt="eematico toys jucarii pachet constructor"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Pachet Constructor</h2>
	                <p>Colecția Constructor include Puzzle-ul triunghiular și Kitul de construire. Copiii pot construi orice vor cu ajutorul pieselor de lemn, șuruburilor și piulițelor sau pot ajuta păsările transformate în piese de puzzle să își găsească locul.</p>
	                <p>Cele două jucării sunt recomandate pentru joacă și bricolaj de la vârsta de 3 ani împreună cu părinții și de la 5 ani singuri. Kitul de construire este însoțit de șuruburi, piulițe și șaibe. Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să construiască și să rezolve puzzle-ul.</p>
	                <span>Vârsta recomandată: <strong>&gt; 3 ani</strong><br/> Preț: <strong>  160 Lei</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Pachetul Constructor (kit-uri de asamblare)')" :height="'auto'">SUNT INTERESAT</v-btn>                  
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Pocket Marble Run</h2>
	                <p>Opțiunile sunt multiple când vine vorba despre prima jucărie asamblabilă și dezasamblabilă eematico - Pocket Marble Run. Piese de lemn, șuruburi, piulițe formează împreună un mic panou care îți antrenează cunoștintele despre gravitație, inerție, viteză, forță de frecare și multe altele. Este o jucărie kinetică, iar în final poate fi personalizată.</p>
	                <p>Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să își asambleze jucăria. Sau puteți să urmăriți filmulețul instrucțional din spatele QR code-ului.</p>
	                <span>Vârsta recomandată: <strong>&gt; 5 ani</strong><br/> Preț: <strong> 108 Lei </strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Marble Run')" :height="'auto'">SUNT INTERESAT</v-btn>              
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-jucarii-pocket-marble-run.jpg" class="fluid-img" alt="eematico toys pocket marble run"/>
	            </v-col>            
	          </v-row>  
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-scientists.jpg" class="fluid-img" alt="eematico toys jucarii Jumpin' Scientists"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Jumpin' Scientists</h2>
	                <p>Jumpin' Scientists vin în săculețe și pot fi asamblate chiar și de copii de peste 3 ani. Jucăria te provoacă să găsești locul potrivit al fiecărei piese de lemn, să le prinzi cu șuruburi și piulițe, să îi adaugi sfoara și să testezi marioneta proaspăt creată. Marionetele vin cu personaje diferite, mai exact, vei găsi chipurile unor oameni de știință faimoși: Nicola Tesla, Marie Curie, Rosalind Franklin și Alexander Gramah Bell. Înauntru găsești și niste mici broșuri despre oamenii de știință reprezentați prin marionete percum și instrucțiuni pentru un experiment legat de domeniile în care s-au făcut remarcați.</p>
	                <p>Agerimea și intuiția (și poate chiar tu) îl vor ajuta pe copilul tău să își asambleze jucăria. Vă puteți folosi, desigur, de instrucțiunile din kit.</p>
	                <span>Vârsta recomandată: <strong>&gt; 3 ani</strong><br/> Preț: <strong>  40 Lei</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Jumpin Scientists')" :height="'auto'">SUNT INTERESAT</v-btn>                
	              </div>
	            </v-col>
	          </v-row>                                                          
	        </v-col>
	      </v-row>
	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle">DESPRE NOI</h2>
	          <div class="custom-about-us">
	            <p>Credem că joaca este mecanismul fundamental de învățare și folosim acest concept pentru a crea experiențe de învățare practice relevante și inovative pentru copii. Astfel, creăm cursuri practice și materiale didactice care transformă învățarea în joacă de copil.</p>

	            <p>Facem asta de mai bine de trei ani timp în care am creat mai bine de 350 de ore de conținut educațional, pentru peste 3000 de copii, cu 600 de activități și tot atâtea materiale didactice (jucării) sau proiecte de bricolaj pentru cei mici.</p>

	            <p>Deoarece misiunea noastră este să oferim aceste experiențe de învățare cât mai multor copii am hotărât să ne folosim energia si experiența pentru a dezvolta propria linie de jucării educaționale. Folosind experiența noastra în designul și creerea de materiale educaționale, folosite și îndrăgite de atâția copii de-a lungul anilor, ne-am apucat să facem jucării care transforme joaca într-o experiența cât mai bogată și utilă. Și astfel să dăm copiilor mai mult timp pentru joacă…</p>
	          </div>
	          <img src="../static/eematico-toys-team.jpg" alt="eematico toys team" class="fluid-img">
	        </v-col>
	      </v-row>
	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle">CONTACTEAZĂ-NE</h2>
	          <v-form ref="form" v-model="valid" :lazy-validation="lazy" id="contact-form">
	          <v-row>
	            <v-col md="12" cols="12">
	              <v-text-field v-model="name" :counter="50" :rules="nameRules" label="Nume*" required></v-text-field>
	              <v-text-field v-model="surName" label="Surname*" class="custom-surname"></v-text-field>
	            </v-col>
	            <v-col sm="6" cols="12">
	              <v-text-field v-model="email" :rules="emailRules" label="E-mail*" required></v-text-field>
	            </v-col>
	            <v-col sm="6" cols="12">
	              <v-text-field v-model="phone" :rules="phoneRules" label="Telefon*" required></v-text-field>
	            </v-col>
	            <v-col sm="12" cols="12">
	                <p>Sunt interesat de*:</p>
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Automaton (kit de asamblare)" label="Automaton (kit de asamblare)" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Carusel (kit de asamblare)" label="Carusel (kit de asamblare)" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                </v-row>
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Geo—puzzle" label="Geo—puzzle" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Presa de ștampile (kit de asamblare)" label="Presa de ștampile (kit de asamblare)" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                </v-row> 
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Kitul de construire" label="Kitul de construire" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                  <v-col sm="6" cols="12">
						<v-checkbox v-model="product" :rules="productRules" value="RuboCar" label="Rubo car (kit de asamblare)" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                </v-row> 
	                <v-row>
	                  <v-col sm="6" cols="12">
	                     <v-checkbox v-model="product" :rules="productRules" value="Racing Kit (kit de asamblare)" label="Racing Kit (kit de asamblare)" required :hide-details="true"></v-checkbox>  
	                  </v-col>	                	
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Toy Sixpack (kit-uri de asamblare)" label="Toy Sixpack (kit-uri de asamblare)" required :hide-details="true"></v-checkbox>                  
	                  </v-col>
	                </v-row>
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Pachetul Dinamic (kit-uri de asamblare)" label="Pachetul Dinamic (kit-uri de asamblare)" required :hide-details="true"></v-checkbox>
	                  </v-col>	                	
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Pachetul Discovery (kit-uri de asamblare)" label="Pachetul Discovery (kit-uri de asamblare)" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                </v-row>
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Pachetul Constructor (kit-uri de asamblare)" label="Pachetul Constructor (kit-uri de asamblare)" required :hide-details="true"></v-checkbox>
	                  </v-col>	                	
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Marble Run" label="Marble Run" :hide-details="true" required></v-checkbox>
	                  </v-col>
	                </v-row>
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Jumpin Scientists" label="Jumpin Scientists"></v-checkbox>
	                  </v-col>	                	
	                </v-row>
	            </v-col>            
	          </v-row>
	          <v-row cols="12">
	            <v-col cols="12">
	               <v-textarea solo name="input-7-4" v-model="message" :counter="500" :rules="messageRules" label="Mesaj*" ></v-textarea>
	            </v-col>
	          </v-row>
	            <v-col md="12" cols="12">
	              <v-text-field v-model="voucherCode" label="Cod Voucher"></v-text-field>
	            </v-col>          
	          <v-row>
	            <v-col cols="12">
	              <v-checkbox v-model="checkbox" :rules="[v => !!v || 'You must agree terms and condition to continue!']" label="Esti de acord cu Termenii si conditiile?*" required></v-checkbox>
	            </v-col>
	          </v-row>
	          <v-row>
	          	<v-col cols="12">
					<p>Disclaimer:</p>

					<p>Suntem la începutul aventurii noastre cu manufactura eematico de jucării. Putem livra așadar, la comandă, un număr limitat de jucării. Vom face toate eforturile ca jucăriile să ajunga cât mai repede la tine însă, deoarece nu ținem un stoc mare, este posibil sa dureze un pic. Singura modalitate de plată care o putem oferi în acest moment este varianta ramburs. Pe masură ce ne dezvoltăm vom adăuga si ale metode. Transportul nu este inclus în preț însa vom cauta metodele cele mai convenabile pentru tine. Ce putem spune sigur este că pentru comenzi de peste 300 lei oferim transport gratuit. Deși investim cât mai mult în calitate, fiind vorba în general despre kituri de asamblare,  putem oferi, funcție de situație, garanții limitate...</p>

					<p>CONSIMȚĂMÂNT DATE PERSONALE: Prin trimiterea acestui formular esti de acord cu folosirea de către noi a datelor tale personale, cu Politica noastra de confidențialitate și noile Condiții de utilizare pe care le poți găsi in partea de jos a paginii. eematico Research va folosi informația pe care o furnizati in acest formular pentru a realiza înscrierea copilului dvs., pentru păstra legătura cu dvs., pentru a vă furniza noutăți și în scopuri de marketing. Datele ce urmeaza a fi colectate se refera la : nume, prenume, numar de telefon, adresa de e-mail, nume, prenume copil. Societatea noastra va putea colecta si stoca aceste informatii in forme diverse (ex., in forma scrisa, electronica, etc.). Acestea vor fi stocate pe o perioada de 5 ani de la completarea si trimiterea formularului . Am implementat anumite masuri de securitate pentru a asigura confidentialitatea informatiilor din baza noastra de date, in conformitate cu standardele minime de securitate impuse de legislatia relevantă.</p>
	          	</v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12">
	                <button class="v-btn custom-button-form" @click.prevent="validate">Trimite</button>
	            </v-col>
	          </v-row>
	          <v-row>
	          	<v-col cols="12">
					<v-alert type="success" v-if="showMsgProduct">
						Cererea a fost trimisa cu succes!
					</v-alert>   
					<v-alert type="error" v-if="errorSubmit">
						A aparut o eroare, va rugam sa reincercati!
					</v-alert> 					
	          	</v-col>
	          </v-row>
	          </v-form>                 
	        </v-col>
	      </v-row>
	    </v-container>    
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col text-center">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle">PROGRAME eematico</h2>
	          <p class="custom-para-programe">Înainte de a face jucării am început prin a crea și livra programe educaționale (cursuri) inovative bazate pe joacă, construit și meșterit pentru copii de 3-6 ani și 7-12 ani. Hai să le descoperi pe site-ul nostru pentru cursuri și programe.</p>
	          <a class="v-btn custom-button-programe" target="_blank" rel="noopener" href="http://eematico.org/">VEZI CURSURI</a>
	        </v-col>    
	      </v-row>
	    </v-container>	
	</div>
</template>
<script>
  export default{
    data(){
      return{
        valid: true,
        name: '',
        nameRules: [
          v => !!v || 'Campul "Nume" este obligatoriu',
          v => (v && v.length <= 50) || 'Campul "Nume" trebuie să aibă cel mult 50 de caractere',
        ],
        surName:'',
        phone:'',
        phoneRules:[
          v => !!v || 'Campul "Telefon" este obligatoriu',
        ],
        email: '',
        emailRules: [
          v => !!v || 'Campul "E-mail" este obligatoriu',
          v => /.+@.+\..+/.test(v) || 'Campul "E-mail" nu este valid',
        ],
        product:[],
        productRules:[
          v => v.length > 0  || "Trebuie selectat cel putin un produs",
        ],
        message:'',
        messageRules:[
          v => !!v || 'Campul "Mesaj" este obligatoriu',
          v => (v && v.length <= 500) || 'Campul "Mesaj" trebuie să aibă cel mult 50 de caractere',
        ],
        voucherCode:'',
        checkbox: false,
        lazy: false,
        validNewsletter:true,
        emailNewsletter:'',
        emailRulesNewsletter:[ v => !!v || 'Campul "E-mail" este obligatoriu',v => /.+@.+\..+/.test(v) || 'Campul "E-mail" nu este valid',],
        fab: false,
        desktopHide:  window.innerWidth > 600 ? false : true,
        mobileHide:   window.innerWidth < 600 ? false : true,
        showMsgProduct:false,
        errorSubmit:false,        
          }
    },
    methods: {
    	scrollToProducts(){
			document.querySelector('#products').scrollIntoView({behavior: 'smooth'});
    	},
    	goToForm(value){
    		document.querySelector('#contact-form').scrollIntoView({behavior: 'smooth'});
    		this.product.push(value);
    	},
        validate() {
            if (this.$refs.form.validate()){
              if(this.surName===''){
              	this.errorSubmit=false;
              	var _this  = this;
                this.$axios.post('product.php', {
                  name: this.name,
                  phone: this.phone,
                  email: this.email,
                  product: this.product,
                  message:this.message,
                  voucherCode: this.voucherCode,
                  TermsAndCondition: this.checkbox,
                  eematicoProduct: true
                })
                .then(function (response) {
                  if(response.data===1){
						_this.showMsgProduct = true;
						_this.$refs.form.reset();
						_this.name =""
						_this.phone="";
						_this.email="";
						_this.product=[];
						_this.message='';
						_this.voucherCode='';
						_this.checkbox=false;                 
                  }else{
                    _this.errorSubmit = true;
                    _this.$refs.form.reset();
						_this.showMsgProduct = true;
						_this.name =""
						_this.phone="";
						_this.email="";
						_this.product=[];
						_this.message='';
						_this.voucherCode='';
						_this.checkbox=false;                        
                  }
                  
                })
              }else{
                this.errorSubmit = true;
				this.showMsgProduct = true;
				this.name =""
				this.phone="";
				this.email="";
				this.product=[];
				this.message='';
				this.voucherCode='';
				this.checkbox=false;                    
              }
           }	
          },
    }
  }
</script>